module.exports = __webpack_public_path__ + "a09b51cfc77e93cfd0f2393d9db1d2.png";